import { BRANDS_GET_ENTITIES } from '../action-types/brands-types';

const initialState = {
  loading: false,
  brands: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case BRANDS_GET_ENTITIES.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case BRANDS_GET_ENTITIES.SUCCESS:
      return {
        ...state,
        brands: action.payload,
      };
    default:
      return state;
  }
}
